export default __webpack_public_path__ + "static/decoration-3-7bece6084b7da5174152464457b96f02.png";